import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listDemandBreakdownModes } from '@ebalance/proto/bffuser/v1/demand_breakdown_mode_service-DemandBreakdownModeService_connectquery'
import {
  ListDemandBreakdownModesRequestSchema,
  type ListDemandBreakdownModesResponse,
} from '@ebalance/proto/bffuser/v1/demand_breakdown_mode_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 想定モードの一覧 (組織の全エリア分)。エリアでの絞り込みは表示側の仕事で、再取得しない
 * (`rowsInArea`)。
 *
 * 取得失敗は画面内で扱う (取得前の失敗はタブを出さない、取得後の再取得失敗はタブの中の Alert)。
 * error boundary (全画面エラー) に飛ばさないよう、global QueryClient の `throwOnError: true` を
 * 本 query だけ `false` に上書きする (docs/guides/frontend-coding-guide.yaml「queries は
 * throwOnError: true」からの意図的な逸脱。先例: useDemandGroupDirectory)。
 */
export function useDemandBreakdownBoard(): UseQueryResult<
  ListDemandBreakdownModesResponse,
  ConnectError
> {
  return useQuery(
    listDemandBreakdownModes,
    create(ListDemandBreakdownModesRequestSchema, {}),
    { throwOnError: false },
  )
}
